export default "__VITE_ASSET__2d34306b__"